module.exports = __webpack_public_path__ + "img/5356045.jpg";